
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.236 9.302c-1.13-1.038-2.604-1.666-4.22-1.666-1.615 0-3.09.628-4.222 1.668a.178.178 0 00-.016.238l.724.91c.058.071.16.08.229.018a4.805 4.805 0 013.285-1.306c1.26 0 2.41.492 3.286 1.304.068.062.17.053.229-.019l.723-.91a.177.177 0 00-.018-.237zm2.359-2.972c-1.782-1.568-4.075-2.512-6.579-2.512-2.504 0-4.796.944-6.58 2.512a.177.177 0 00-.02.24l.723.91c.056.072.158.08.225.02 1.533-1.344 3.504-2.155 5.652-2.155s4.12.81 5.65 2.156c.069.059.17.05.226-.022l.723-.91a.178.178 0 00-.02-.24zM17.94 3.38C15.5 1.268 12.378 0 8.976 0 5.596 0 2.493 1.252.06 3.339a.168.168 0 00-.06.116.179.179 0 00.038.126l.723.91c.057.07.157.08.223.023C3.17 2.645 5.948 1.527 8.976 1.527c3.05 0 5.847 1.135 8.038 3.027.068.06.168.049.225-.023l.723-.91a.174.174 0 00-.022-.24zM7.71 12.642c0 .36.135.706.377.96.24.255.568.398.909.398.341 0 .668-.143.91-.398.24-.254.376-.6.376-.96s-.136-.705-.377-.96a1.253 1.253 0 00-.909-.397c-.341 0-.668.143-.91.397-.24.255-.376.6-.376.96z","fill":"#37474F"}})])
          )
        }
      }
    